var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 13.765c-.353 0-.588-.236-.588-.588 0-1.06.47-2.118 1.411-2.824.47-.353.589-.824.47-1.412-.117-.47-.47-.941-1.058-1.059-.47-.117-.823 0-1.176.236-.353.235-.471.706-.471 1.058 0 .353-.235.589-.588.589s-.588-.236-.588-.589c0-.823.353-1.529.94-2 .589-.47 1.413-.705 2.118-.47.942.235 1.765.941 2 2 .236.941-.117 1.882-.94 2.588-.589.47-1.06 1.177-1.06 1.883.118.352-.117.588-.47.588zM12 17.294c-.118 0-.353-.117-.47-.235-.118-.118-.118-.236-.118-.353 0-.118 0-.353.117-.47a.569.569 0 01.824 0c.117.117.235.235.235.47 0 .117-.118.353-.235.353 0 .117-.236.235-.353.235z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47 22 2 17.53 2 12S6.47 2 12 2s10 4.47 10 10-4.47 10-10 10zm0-18.824c-4.824 0-8.824 4-8.824 8.824 0 4.823 4 8.823 8.824 8.823 4.823 0 8.823-4 8.823-8.823 0-4.824-4-8.824-8.823-8.824z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.3e4c5667dedc3f1c05992860f8a129f9.svg";
export { ForwardRef as ReactComponent };